import React from "react";
import { component_tool } from "@/tool";
let { WizModal } = component_tool;
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
const componentName = "classStudentSurvey";
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {},
    formItem: {}
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {},
    formItem: {}
  },
  {
    title: '手机号',
    name: 'mobile',
    tableItem: {}
  },
  {
    title: "组织名称",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
    }
  },
  {
    title: "岗位",
    name: "positionIds",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    }
  },
  {
    title: "组织名称",
    name: "orgName",
    dataIndex: "orgName",
    tableItem: {},
    formItem: {}
  },
  {
    title: "组织代码",
    name: "orgCode",
    dataIndex: "orgCode",
    tableItem: {},
    formItem: {}
  },
  {
    title: '岗位',
    name: 'positionName',
    tableItem: {},
    formItem: {}
  },
  {
    title: '任职状态',
    name: 'jobStateName',
    tableItem: {},
    formItem: {}
  },
  {
    title: "是否请假",
    name: "leaveState",
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" }
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "是否答卷",
    name: "isJoinSurvey",
    dataIndex: "isJoinSurvey",
    searchItem: {
      type: "select"
    },
    tableItem: {},
    dict: [
      { code: true, codeName: "是" },
      { code: false, codeName: "否" }
    ],
    formItem: {
      type: "radio",
      initialValue: true
    }
  },
  {
    title: '答卷时间',
    name: 'submissionDate',
    tableItem: {},
    formItem: {}
  },
  {
    title: '满意度评分',
    name: 'scoreAvg',
    tableItem: {},
    formItem: {}
  }

];

const templateConfig = (date) => {
  const {onSelect,classInfoId,_btnLookUserFun,_this,surveyInfo} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedClassResultRows
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck:false,
        searchBarProps: {
          // cols: {
          //   xs: 24,//总的单元格数
          //   md: 12,//在。。。的分辨率下占多少单元格
          //   xl: 12//在。。。的分辨率下占多少单元格
          // },
          buttonSort: ['exportClassStudentSurveyByCondition','exportClassStudentSurveyDetailByCondition'],
          buttons: [
            {
              key: 'exportClassStudentSurveyByCondition',
              custom: true,
              params: { icon: 'export', children: '导出问卷记录', type:'primary' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportClassStudentSurveyByCondition",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportClassStudentSurveyDetailByCondition',
              custom: true,
              params: { icon: 'export', children: '问卷统计结果', type:'primary'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "jumpPageShow",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                 _this.jumpPage('push', '/face/classList/classAideDetail/classStudentSurveyList/surveyRecordInfo', surveyInfo)
                }
              },
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect
        },
        commonOperate: {
          update: true
        },
        rowOperateSort: ['showSatisfactionRecord'],
        rowOperateView: [
          {
            key: "showSatisfactionRecord",
            custom: true,
            params: {children: "查看问卷"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "jumpPageShow",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
               _this.jumpPage('push', '/face/classList/classAideDetail/classStudentSurveyList/surveyRecordInfoDetail', record)
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: true };
              if (record.record && record.record.isJoinSurvey){
                result = {disabled: false}
              }
              return  result;
            },

          }
        ]
      }
    }
  }
};



let reduxTemplateCofig = args => {
  const { classInfoId ,surveyId} = args;
  const apis = {
    list: {
      path: `${componentName}/queryClassStudentSurveyPage`,
      payload: {
        key: `${componentName}@queryClassStudentSurveyPage`,
        apiParams: { classInfoId: classInfoId,surveyId: surveyId}
      }
    },
    exportClassStudentSurveyByCondition: {//导出数据方法
      path: `${componentName}/exportClassStudentSurveyByCondition`,
      payload: {
        key: `${componentName}@exportClassStudentSurveyByCondition`,
        apiParams: { classInfoId: classInfoId,surveyId: surveyId}
      }
    },
    queryClassStudentSurveySummary:{
      path: `${componentName}/queryClassStudentSurveySummary`,
      payload: {
        key: `${componentName}@queryClassStudentSurveySummary`,
        apiParams: { classInfoId: classInfoId,surveyId: surveyId}
      }
    },
    exportClassStudentSurveyDetailByCondition:{
      path: `${componentName}/exportClassStudentSurveyDetailByCondition`,
      payload: {
        key: `${componentName}@exportClassStudentSurveyDetailByCondition`,
        apiParams: { classInfoId: classInfoId,surveyId: surveyId}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list","queryClassStudentSurveySummary"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
